import { ResponseWithPagination } from '@/types/api'

export enum FlowEntityType {
    TRIGGER = 'trigger',
    ACTION = 'action',
    CONDITION_GROUP = 'condition_group',
    LOOP = 'loop',
    CONDITION = 'condition',
}

export type IFlowEntity = {
    id: string
    _id: string
    entity_id: string
    name: string
    description: string
    icon?: string
    category: string
    input_schema: Record<string, any>
    output_schema: Record<string, any>
    prompt: string
    system_prompt: string
    type: FlowEntityType
    sub_type: string
    interactive: boolean
    active: boolean
    internal: boolean
    createdAt: string
    updatedAt: string
    allow_custom_input_schema: boolean
    allow_custom_output_schema: boolean
    parentId?: string
}

export type APIFlowEntityResponse = ResponseWithPagination<IFlowEntity>
